import { Component, OnInit } from '@angular/core';
import { GlobalsService } from 'src/app/services/globals/globals.service';
import { LottosService } from 'src/app/services/lottos/lottos.service';
import { Language } from 'src/app/tools/language/language';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {
  langs = environment.multisite.langs;
  lang: any = Language.currentLanguage.lenid;
  cdnProducts= 'https://d3tmfelegj51yl.cloudfront.net';
  sys: string;
  lottoId: number;
  siteLogo: string;

  constructor(
    private _lotto: LottosService, 
    public globalSrv: GlobalsService) { }

  ngOnInit(): void {
    this.setSystem();
  }

  setSystem(): void {
    if (environment.lottery.lot_id !== 0) {
      this._lotto.lottoObservable$.subscribe((lottoObj) => {
        this.lottoId = lottoObj['id'];
      });
    }
    this.sys = this.globalSrv.getSystem().site;
  }

}
